export { ZoraRuntimeCapabilities } from './ZoraRuntimeCapabilities.web';
